module.exports = __webpack_public_path__ + "img/icon-light-tag.a306da54.svg";